import { modifier } from 'ember-modifier';

export default modifier((element, [active], { onReset }) => {
  let wasActive = false;

  const checkActiveChange = () => {
    // Si cambió de true a false, ejecutar reset
    if (wasActive && !active) {
      if (onReset) {
        onReset();
      }
    }
    wasActive = active;
  };

  checkActiveChange();
});